
export default function Services() {
  const services = [
    {
      icon: 'ri-layout-masonry-fill',
      title: 'Branda Baskı',
      description: 'Dayanıklı ve kaliteli branda baskı hizmetleri. Dış mekan kullanımına uygun, UV dayanımlı ve uzun ömürlü brandalar üretiyoruz.',
      image: 'https://public.readdy.ai/ai/img_res/5c87924f39eb3093711a67eac1096734.jpg'
    },
    {
      icon: 'ri-store-2-fill',
      title: 'Cephe Giydirme',
      description: 'Mağaza ve işyeri cephe giydirme çözümleri. Markanızı en iyi şekilde temsil eden profesyonel cephe tasarımları yapıyoruz.',
      image: 'https://readdy.ai/api/search-image?query=modern%20storefront%20facade%20with%20vibrant%20red%20commercial%20signage%20and%20professional%20building%20wrap%20installation%20on%20clean%20white%20commercial%20building%20exterior&width=600&height=400&seq=service-002&orientation=landscape'
    },
    {
      icon: 'ri-advertisement-fill',
      title: 'Reklam Panoları',
      description: 'İç ve dış mekan reklam panoları. LED tabela, totem, ışıklı kutu harf ve her türlü reklam panosu üretimi yapıyoruz.',
      image: 'https://readdy.ai/api/search-image?query=illuminated%20red%20advertising%20billboard%20and%20signage%20panels%20with%20professional%20LED%20lighting%20in%20modern%20commercial%20setting%20with%20clean%20white%20background&width=600&height=400&seq=service-003&orientation=landscape'
    },
    {
      icon: 'ri-car-fill',
      title: 'Araç Giydirme',
      description: 'Araç kaplama ve reklam giydirme hizmetleri. Ticari araçlarınızı mobil reklam aracına dönüştürüyoruz.',
      image: 'https://readdy.ai/api/search-image?query=commercial%20vehicle%20wrap%20with%20vibrant%20red%20advertising%20graphics%20being%20applied%20to%20white%20delivery%20van%20in%20professional%20auto%20wrap%20facility&width=600&height=400&seq=service-004&orientation=landscape'
    },
    {
      icon: 'ri-printer-fill',
      title: 'Dijital Baskı',
      description: 'Yüksek çözünürlüklü dijital baskı hizmetleri. Poster, afiş, katalog ve her türlü tanıtım materyali baskısı yapıyoruz.',
      image: 'https://readdy.ai/api/search-image?query=high%20resolution%20digital%20printing%20machine%20producing%20vibrant%20red%20marketing%20materials%20and%20posters%20in%20modern%20print%20facility%20with%20clean%20white%20background&width=600&height=400&seq=service-005&orientation=landscape'
    }
  ];

  return (
    <section id="hizmetler" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Hizmetlerimiz
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Branda baskıdan dijital baskıya, araç giydirmeden cephe kaplama hizmetlerine kadar geniş ürün yelpazesi
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-14 h-14 bg-red-600 rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
                <a 
                  href="#iletisim" 
                  className="inline-flex items-center text-red-600 font-semibold hover:text-red-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Detaylı Bilgi
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-20 bg-gradient-to-r from-red-600 to-red-700 rounded-3xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Projeniz İçin Özel Teklif Alın
          </h3>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Uzman ekibimiz size en uygun çözümü sunmak için hazır. Hemen iletişime geçin!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="#iletisim" 
              className="bg-white text-red-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Teklif İste
            </a>
            <a 
              href="tel:+908503073704" 
              className="bg-red-800 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-red-900 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2"></i>
              +90 850 307 3704
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
